import {Table, TableContainer, Tbody, Th, Thead, Tr } from "@chakra-ui/react";
import CompanyTableItem from "./CompanyTableItem";
import type { CompanyTableProps } from "./types";

const CompanyTable = ({ data, onPressEdit, onPressDelete, onPressPlayStop }:CompanyTableProps) => {
    return (
        <TableContainer bg="white" borderRadius={8} p={2} shadow="md">
            <Table variant="simple" size="sm">
                <Thead>
                    <Tr>
                        <Th>Empresa</Th>
                        <Th>Fecha de creacion</Th>
                        <Th>Fecha de actualizacion</Th>
                        <Th>Estatus</Th>
                        <Th isNumeric></Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {data?.map((item) => (
                        <CompanyTableItem 
                            key={item.id} 
                            item={item} 
                            onPressEdit={onPressEdit} 
                            onPressDelete={onPressDelete}
                            onPressPlayStop={onPressPlayStop}
                        />
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    )
}

export default CompanyTable